<template>
  <v-container mt-5>
      <h4 class="text-center mb-2">Vyber si blok kde bývaš</h4>
      <v-row 
        v-if="$vuetify.breakpoint.smAndUp"
        justify="center">
        <v-btn-toggle 
          @change="$emit('change', buildingType)" 
          v-model="buildingType">
            <v-btn
            v-for="(building,index) in buildings"
            :key="index"
            :disabled="checkIfDisable(building)"
            :value="building"
            color="accent darken-1"
            class="ml-1">
                {{building}}
            </v-btn>  
        </v-btn-toggle>
      </v-row>
      
      <v-row 
        v-else
        v-for="(building,index) in buildings" 
        :key="index"
        justify="center"
        class="my-1">
          <v-btn-toggle 
          @change="$emit('change', buildingType)" 
          v-model="buildingType">          
              <v-btn
              width="250"
              :value="building"
              :disabled="checkIfDisable(building)"
              color="accent darken-1">
                  {{building}}
              </v-btn>  
          </v-btn-toggle>
      </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "ChooseBuilding",
    data: () => ({
        buildings: [
            "Štúrak",
            "Átriové domky",
            "Manželáky"
        ],
        buildingType: null
    }),
    props: ["used"],
    methods:{
      checkIfDisable(building){
        return this.buildingType === building
      }
    }
  }
</script>

